import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, Rocket } from "lucide-react";

const SERVICES = [
  { label: "Play — Gaming Lounge & Day Passes", to: "/lounge", hash: "pricing" },
  { label: "Book — Parties & Private Events", to: "/events", hash: "booking-form" },
  { label: "Build — AI Game Lab (make your own game)", to: "/ai-studio", hash: "" },
  { label: "Fix — Device & Console Repair", to: "/repair", hash: "quote-form" },
  { label: "Make — Custom Maker Projects", to: "/maker", hash: "estimator" },
  { label: "Protect — Business IT & Cybersecurity", to: "/business-it", hash: "it-consult" },
];

export function ServicePicker() {
  const [choice, setChoice] = useState("");
  const navigate = useNavigate();

  const go = () => {
    const svc = SERVICES.find((s) => s.label === choice);
    if (!svc) return;
    navigate(svc.to);
    if (svc.hash) {
      setTimeout(() => document.getElementById(svc.hash)?.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
    }
  };

  return (
    <div data-testid="service-picker" className="glass w-full max-w-2xl rounded-xl border border-neon-cyan/30 p-5">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-neon-cyan" data-testid="service-picker-label">
        ▶ Select your adventure — we'll take you straight there
      </p>
      <div className="mt-3 flex flex-col gap-3 sm:flex-row">
        <div className="relative flex-1">
          <select
            value={choice}
            onChange={(e) => setChoice(e.target.value)}
            data-testid="service-picker-select"
            className="w-full appearance-none rounded-md border border-white/15 bg-ink px-4 py-3 pr-10 font-display text-sm font-bold uppercase tracking-wide text-white outline-none transition-colors focus:border-neon-cyan"
          >
            <option value="" disabled>What are you here for?</option>
            {SERVICES.map((s) => (
              <option key={s.label} value={s.label}>{s.label}</option>
            ))}
          </select>
          <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neon-cyan" />
        </div>
        <button
          onClick={go}
          disabled={!choice}
          data-testid="service-picker-go-button"
          className="inline-flex items-center justify-center gap-2 rounded-md bg-neon-cyan px-6 py-3 font-display text-sm font-extrabold uppercase tracking-wide text-ink transition-all enabled:hover:bg-white disabled:cursor-not-allowed disabled:opacity-40"
        >
          Take Me There <Rocket className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
